var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.355469)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9099",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.355469",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9099)" } }, [
        _c("path", {
          attrs: { d: "M46.3555 0H0.355469V46H46.3555V0Z", fill: "#E21E21" },
        }),
        _c("path", {
          attrs: {
            d: "M36.4963 0H25.305C22.8121 1.21275 20.4664 2.82912 18.3959 4.89958H18.3958C8.39931 14.8962 8.39931 31.1037 18.3958 41.1004H18.3959C20.4664 43.1709 22.8121 44.7872 25.305 46H36.4963V0Z",
            fill: "#F47277",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.3536 0H35.1625C32.6696 1.21275 30.3237 2.82912 28.2533 4.89958H28.2533C18.2567 14.8962 18.2567 31.1037 28.2533 41.1004H28.2533C30.3237 43.1709 32.6696 44.7872 35.1625 46H46.3536V0Z",
            fill: "#EC4347",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }